import React from 'react'
import "./blog2.scss"

function Blog2() {
  return (
 
  <div className='blog'><div class="container-fluid position-relative half-fluid">
  <div class="container">
    <div class="row">

     
     

      <div class="col-lg-6 py-5 pe-lg-5">
        <h1 className='blog-titre'>Dipavali, Grand Raid, Geekali...</h1>
     
        <p className='blog-para'>Nous participons activement à de nombreux événements au cours de l'année.
        À travers ces événements, l’association partage son amour de la danse avec le plus grand nombre.
        </p>
        
      </div><div class="col-lg-6 position-lg-absolute right-half h-100">
        <div class="image"></div>
      </div>
    </div> 
  </div>
</div>
    <div class="container-fluid position-relative half-fluid">
  <div class="container">
    <div class="row">

   
      

      
      <div class="col-lg-6 offset-lg-6 py-5 ps-lg-5">
        <h1 className='blog-titre'>Nos représentations</h1>
      
        <p className='blog-para'>Nous nous produisons lors de grandes festivités comme le Dipavali, ou encore le Grand Raid, avec le  défilé haut en couleur et en proposant des performances dynamiques. 
        <br></br>
        <br></br>
          Le salon Geekali, en mettant à l’honneur la K-pop. 
          <br></br>
          Nous participons aussi à "En Rou Lib", en faisant danser petits et grands sur des rythmes variés. 
          <br></br>
          <br></br>
          Chaque 13 juillet, Nous défilons avec passion pour célébrer la fête nationale,
         et nous clôturons l’année en beauté lors de la Fête des Lentilles et Noêl, dans une ambiance festive et chaleureuse.</p>
        
      </div><div class="col-lg-6 position-lg-absolute left-half h-100">
        <div class="image2"></div>
        <div class="neon-gradient"></div>
	<div class="neon-light"></div>
      </div>
      
    </div>
  </div>
</div>



  </div>
  )
}

export default Blog2